module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iSWNvbnMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDMyIDMyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2MyMDk1YTt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjMsOEg5QTgsOCwwLDAsMCw5LDI0SDIzQTgsOCwwLDAsMCwyMyw4Wm0uOTIsMTNhNSw1LDAsMSwxLDUtNUE1LDUsMCwwLDEsMjMuOTIsMjFaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/on.svg
// module id = gMXa
// module chunks = 1